// TODO implement AddPaymentInfo event
// TODO check if more values can be passed to product and cart pages

// https://business.twitter.com/en/help/campaign-measurement-and-analytics/conversion-tracking-for-websites.html

/**
 * Load Twitter Ads event listeners
 * */

// Pixel load event listener
jQuery(document).on("wpmLoadPixels", () => {

	if (wpmDataLayer?.pixels?.twitter?.pixel_id && !wpmDataLayer?.pixels?.twitter?.loaded) {
		if (wpm.canIFire("ads", "twitter-ads")) wpm.loadTwitterPixel()
	}
})

// add-to-cart event
jQuery(document).on("wpmAddToCart", (event, product) => {

	try {
		if (!wpmDataLayer?.pixels?.twitter?.loaded) return

		if (wpmDataLayer?.pixels?.twitter?.event_ids?.add_to_cart) {
			twq("event", wpmDataLayer.pixels.twitter.event_ids.add_to_cart, {
				value   : product.quantity * product.price,
				currency: wpmDataLayer.shop.currency,
				contents: [{
					content_type : "product",
					content_id   : wpmDataLayer.products[product.id].dyn_r_ids[wpmDataLayer.pixels.twitter.dynamic_remarketing.id_type],
					content_name : product.name,
					content_price: product.price,
					num_items    : product.quantity,
					// content_group_id: null,
				}],
			})
		} else {
			// Legacy event
			twq("track", "AddToCart")
		}
	} catch (e) {
		console.error(e)
	}
})

// view product event
jQuery(document).on("wpmViewItem", (event, product = null) => {

	try {
		if (!wpmDataLayer?.pixels?.twitter?.loaded) return

		let productData = {}

		if (product) {
			productData = {
				value   : product.quantity * product.price,
				currency: wpmDataLayer.shop.currency,
				contents: [{
					content_type : "product",
					content_id   : wpmDataLayer.products[product.id].dyn_r_ids[wpmDataLayer.pixels.twitter.dynamic_remarketing.id_type],
					content_name : product.name,
					content_price: product.price,
					num_items    : product.quantity,
					// content_group_id: null,
				}],
			}
		}

		if (wpmDataLayer?.pixels?.twitter?.event_ids?.view_content) {
			twq("event", wpmDataLayer.pixels.twitter.event_ids.view_content, productData)
		} else {
			// Legacy event
			twq("track", "ViewContent")
		}

	} catch (e) {
		console.error(e)
	}
})

// // view category event
// jQuery(document).on('wpmCategory', function () {
//
// 	if (!wpmDataLayer?.pixels?.twitter?.loaded) return;
//
// 	// twq('track', 'AddToWishlist');
// });

// add-to-wishlist event
jQuery(document).on("wpmAddToWishlist", (event, product) => {

	try {
		if (!wpmDataLayer?.pixels?.twitter?.loaded) return

		let productData = {}

		if (product) {
			productData = {
				value   : product.quantity * product.price,
				currency: wpmDataLayer.shop.currency,
				contents: [{
					content_type : "product",
					content_id   : wpmDataLayer.products[product.id].dyn_r_ids[wpmDataLayer.pixels.twitter.dynamic_remarketing.id_type],
					content_name : product.name,
					content_price: product.price,
					num_items    : product.quantity,
					// content_group_id: null,
				}],
			}
		}

		if (wpmDataLayer?.pixels?.twitter?.event_ids?.add_to_wishlist) {
			twq("event", wpmDataLayer.pixels.twitter.event_ids.add_to_wishlist, productData)
		} else {
			// Legacy event
			twq("track", "AddToWishlist")
		}

	} catch (e) {
		console.error(e)
	}
})

// start checkout event
jQuery(document).on("wpmBeginCheckout", () => {

	try {
		if (!wpmDataLayer?.pixels?.twitter?.loaded) return

		if (wpmDataLayer?.pixels?.twitter?.event_ids?.initiate_checkout) {
			twq("event", wpmDataLayer.pixels.twitter.event_ids.initiate_checkout, {})
		} else {
			// Legacy event
			twq("track", "InitiateCheckout")
		}

	} catch (e) {
		console.error(e)
	}
})

// View search event
jQuery(document).on("pmwEvent:Search", () => {

	try {
		if (!wpmDataLayer?.pixels?.twitter?.loaded) return

		if (wpmDataLayer?.pixels?.twitter?.event_ids?.search) {
			twq("event", wpmDataLayer.pixels.twitter.event_ids.search, {
				search_string: wpm.getSearchTermFromUrl(),
			})
		} else {
			// Legacy event
			twq("track", "Search")
		}

	} catch (e) {
		console.error(e)
	}
})


// view order received page event
// TODO find out under which circumstances to use different values in content_type
jQuery(document).on("wpmOrderReceivedPage", () => {

	try {
		if (!wpmDataLayer?.pixels?.twitter?.loaded) return


		if (wpmDataLayer?.pixels?.twitter?.event_ids?.purchase) {
			twq("event", wpmDataLayer.pixels.twitter.event_ids.purchase, {
				value   : wpmDataLayer.order.value_filtered,
				currency: wpmDataLayer.order.currency,
				conversion_id: wpmDataLayer.order.id,
				contents: Object.values(wpmDataLayer.order.items).map(product => ({
					content_type : "product",
					content_id   : wpmDataLayer.products[product.id].dyn_r_ids[wpmDataLayer.pixels.twitter.dynamic_remarketing.id_type],
					content_name : product.name,
					content_price: product.price,
					num_items    : product.quantity,
					// content_group_id: null,
				})),
			})
		} else {
			// Legacy event
			twq("track", "Purchase", {
				order_id: wpmDataLayer.order.id,
				// content_type: 'product',
				value      : wpmDataLayer.order.value_filtered,
				currency   : wpmDataLayer.order.currency,
				num_items  : wpmDataLayer.order.quantity,
				content_ids: wpm.twitterGetOrderContentIds(),
			})
		}

	} catch (e) {
		console.error(e)
	}
})

